import axios from "axios";
import { ThreadSendReceiveType } from "enums";
import { ThreadAdminListModel, ThreadListModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import { IAPIResult } from "models/interfaces";
import { ThreadAdminSearchOptions } from "models/ThreadAdminSearchOptions";
import { ThreadSearchOptions } from "models/ThreadSearchOptions";

export type EstimateCreatePostDataModel = {
  estimate_list: {
    receive_corp_id: string;
    item_list: {
      item_cd: string;
      quantity: number;
    }[];
  }[];
  thread: {
    thread_title: string;
    payment_type: {
      payment_type_id: number;
      payment_type_name: string;
      pay_month: number;
    };
    message: string;
    file: CommonFileModel[];
    time_limit: string
  };
};
// 見積依頼作成
export async function estimateCreate(options: EstimateCreatePostDataModel) {
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/thread/estimate-create",
    options
  );
  return response.data;
}

export type InquiryCreatePostDataModel = {
  thread: {
    thread_title: string;
    message: string;
    file: CommonFileModel[];
  };
  receive_corp_list: { receive_corp_id: string }[];
};
// 見積依頼作成
export async function inquiryCreate(options: InquiryCreatePostDataModel) {
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/thread/inquiry-create",
    options
  );
  return response.data;
}

export async function adminSearch(options: ThreadAdminSearchOptions) {
  const response = await axios.post<IAPIResult<ThreadAdminListModel>>(
    "/api.d/v1/ec/thread/admin-search",
    options
  );
  return response.data;
}

export async function search(options: ThreadSearchOptions) {
  const response = await axios.post<IAPIResult<ThreadListModel>>(
    "/api.d/v1/ec/thread/search",
    options
  );
  return response.data;
}

export async function update(thread_id: string, type_send: ThreadSendReceiveType,type_receive: ThreadSendReceiveType) {
  const response = await axios.put<IAPIResult>("/api.d/v1/ec/thread/update", {
    thread_id,
    thread_send_type: type_send,
    thread_receive_type: type_receive,
  });
  return response.data;
}
